var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge",class:_vm.type === 1 ? '':'badge--case-study'},[_vm._v(_vm._s(_vm.types[_vm.type]))])
}
var staticRenderFns = []

export { render, staticRenderFns }